/* Yellow Creek native package add-on prototype.
   Only runs when the unpublished theme's native selector is explicitly enabled.
   Existing W3 cart behavior and product settings are not changed. */
(()=> {
  if(window.YCNativeBundlesLoaded)return;
  window.YCNativeBundlesLoaded=true;
  const base=()=>window.Shopify?.routes?.root||'/';
  const json=async(path,payload)=>{
    const res=await fetch(base()+path,{method:payload?'POST':'GET',credentials:'same-origin',
      headers:payload?{'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'}:{},
      body:payload?JSON.stringify(payload):undefined});
    const data=await res.json();
    if(!res.ok)throw new Error(data.description||data.message||'Unable to update cart');
    return data;
  };
  const groups=cart=>{
    const map=new Map();
    for(const item of cart.items){
      const id=item.properties?._yc_native_bundle;
      if(!id)continue;
      if(!map.has(id))map.set(id,{parent:null,children:[]});
      const g=map.get(id);
      if(item.properties?._yc_native_child==='yes')g.children.push(item);
      else g.parent=item;
    }
    return map;
  };
  let busy=false;
  async function modifyGroup(groupId,quantity){
    if(busy)return;
    busy=true;
    try{
      const cart=await json('cart.js');
      const g=groups(cart).get(groupId);
      if(!g)return;
      const updates={};
      if(g.parent)updates[g.parent.key]=quantity;
      for(const child of g.children)updates[child.key]=quantity;
      if(Object.keys(updates).length)await json('cart/update.js',{updates});
      window.location.reload();
    }catch(err){window.alert(err.message);busy=false}
  }
  document.addEventListener('click',e=>{
    const button=e.target.closest('[data-yc-native-remove]');
    if(!button)return;
    e.preventDefault();
    e.stopImmediatePropagation();
    modifyGroup(button.dataset.ycNativeRemove,0);
  },true);
  document.addEventListener('cart:quantity',async e=>{
    const key=e.detail?.[0], qty=Number(e.detail?.[1]);
    if(!key||!Number.isInteger(qty)||qty<0)return;
    const el=e.detail?.[2];
    const row=el?.closest?.('[data-yc-native-parent]');
    if(!row)return;
    e.stopImmediatePropagation();
    e.preventDefault?.();
    await modifyGroup(row.dataset.ycNativeParent,qty);
  },true);
  document.addEventListener('submit',async e=>{
    const form=e.target;
    const root=form.querySelector('[data-yc-native-addons][data-yc-native-active="true"]');
    if(!root)return;
    e.preventDefault();
    e.stopImmediatePropagation();
    if(busy)return;
    busy=true;
    const button=form.querySelector('[name="add"]');
    if(button)button.disabled=true;
    try{
      const formData=new FormData(form);
      const id=Number(formData.get('id'));
      const qty=Number(formData.get('quantity')||1);
      if(!Number.isInteger(id)||!Number.isInteger(qty)||qty<1)throw new Error('Choose a valid treatment and quantity.');
      const group='yc-'+Date.now().toString(36)+'-'+Math.random().toString(36).slice(2,10);
      const properties={_yc_native_bundle:group};
      for(const [name,value] of formData.entries()){
        const match=/^properties\[(.+)\]$/.exec(name);
        if(match)properties[match[1]]=String(value);
      }
      const items=[{id,quantity:qty,properties}];
      for(const cb of root.querySelectorAll('[data-yc-addon-variant]:checked')){
        items.push({id:Number(cb.dataset.ycAddonVariant),quantity:qty,
          properties:{_yc_native_bundle:group,_yc_native_child:'yes'}});
      }
      await json('cart/add.js',{items});
      window.location.assign(base()+'cart');
    }catch(err){
      window.alert(err.message);
      busy=false;
      if(button)button.disabled=false;
    }
  },true);
})();
